<style>
  .month {
    background: #f7f7f8;
    border: 2px solid #f7f7f8;
    box-shadow: none;
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    color: #4c4c4b;
    font-size: 16px;
    padding: 12px 8px;
    margin: 0 0 16px 0;
    text-align: center;
    cursor: pointer;
  }

  .month.active {
    border: 2px solid #ff6452;
  }

  .month.disabled {
    cursor: not-allowed;
  }
</style>

<script>
  export let value = [];
  export let readonly = false;

  let months = [
    {id:1, label: 'January', active: isActiveMonth(1)},
    {id:2, label: 'February', active: isActiveMonth(2)},
    {id:3, label: 'March', active: isActiveMonth(3)},
    {id:4, label: 'April', active: isActiveMonth(4)},
    {id:5, label: 'May', active: isActiveMonth(5)},
    {id:6, label: 'June', active: isActiveMonth(6)},
    {id:7, label: 'July', active: isActiveMonth(7)},
    {id:8, label: 'August', active: isActiveMonth(8)},
    {id:9, label: 'September', active: isActiveMonth(9)},
    {id:10, label: 'October', active: isActiveMonth(10)},
    {id:11, label: 'November', active: isActiveMonth(11)},
    {id:12, label: 'December', active: isActiveMonth(12)}
  ];

  export let label;

  function toggleMonth(id, i) {
    if(readonly) return;
    const exists = value.find((m) => m === id);
    if(exists) {
      months[months.findIndex(m => m.id === id)].active = false;
      value = value.filter((m) => m !== id);
      return value;
    }

    months[i].active = true
    return value.push(id);
  }

  function isActiveMonth(id) {
    return value.find((m) => m === id);
  }

</script>

{#if label}<label>{label}</label>{/if}
<div class="grid-x grid-margin-x small-up-4">
{#each months as month, i}
  <div class="cell">
    <div class:disabled="{readonly}" class:active={month.active} on:click="{e => toggleMonth(month.id, i)}" class="month">
      {month.label}
    </div>
  </div>
{/each}
</div>